import { memo } from "react";

import { setAreSituationsOpen } from "../../model/actions";
import { useAppDispatch } from "../../utils/hooks/useAppDispatch";
import useAppSelector from "../../utils/hooks/useAppSelector";
import Button from "../controls/Button";
import {
  IcDbNavigationExpandLess24,
  IcDbNavigationExpandMore24,
  Warning as WarnIcon,
} from "../icons";

export type PlatformInfoProps = React.HTMLAttributes<HTMLDivElement> &
  React.RefAttributes<HTMLDivElement>;

function PlatformInfo(props: PlatformInfoProps) {
  const dispatch = useAppDispatch();
  const situations = useAppSelector((state) => state.situations);
  const areSituationsOpen = useAppSelector((state) => state.areSituationsOpen);

  if (!situations?.length) {
    return null;
  }

  return (
    <div
      {...props}
      onClick={() => {
        dispatch(setAreSituationsOpen(!areSituationsOpen, true));
      }}
      onKeyDown={(evt: React.KeyboardEvent<HTMLDivElement>) => {
        if (evt.key === "Enter" || evt.key === " ") {
          dispatch(setAreSituationsOpen(!areSituationsOpen, true));
          evt.preventDefault();
        }
      }}
      role="button"
      style={{
        alignItems: "center",
        backgroundColor: "white",
        boxShadow: "0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%)",
        display: "flex",
        fontSize: "clamp(0.8rem, 5vw - 0.25rem, 1rem)",
        justifyContent: "space-between",
        margin: "5px 0",
        paddingRight: "10px",
        ...props.style,
      }}
      tabIndex={0}
    >
      <div>
        <WarnIcon height={64} width={64} />
      </div>
      <div style={{ flex: 1, paddingRight: "10px" }}>
        Es liegen Meldungen vor.
      </div>

      <Button
        disabled={false}
        onClick={(evt: React.MouseEvent<HTMLButtonElement>) => {
          dispatch(setAreSituationsOpen(!areSituationsOpen, true));
          evt.stopPropagation();
        }}
        title={
          areSituationsOpen
            ? "Alle Störungsmeldungen schließen"
            : "Alle Störungsmeldungen öffnen"
        }
      >
        {areSituationsOpen ? (
          <IcDbNavigationExpandLess24 focusable={false} size={24} />
        ) : (
          <IcDbNavigationExpandMore24 focusable={false} size={24} />
        )}
      </Button>
    </div>
  );
}

export default memo(PlatformInfo);
